<template>
    <component :is="listContainer || 'ul'" :id="'label_' + uniqueId" class="booking_label">
        <li v-for="label in selectedLabels" :key="label.id"
            class="btn btn-success btn-rounded blue-label-btn"
            data-toggle="modal" :data-target="`#AddLabelPopup${actionName}`" :style="`margin:4px;border:1px solid transparent;background-color:${label.label_color}`">
            {{ getLabelName(label) }}
        </li>
        <confirmation-popup
            title="Add Label"
            message=""
            :id="`AddLabelPopup${actionName}`"
            :showConfirmBtn="true"
            :showCreateBtn="true"
            confirm-btn-text="Apply"
            :show-cancel-btn="true"
            cancel-btn-text="Create New Label"
            @on-confirm=""
            @on-cancel="openNewLabelModal"
        >
         <common-label-template
             :modal-id="`AddLabelPopup${actionName}`"
             v-model="selectedLabels"
             :action-name="actionName" :all-labels="allLabels"
         >

         </common-label-template>
        </confirmation-popup>

        <confirmation-popup
            title="Create new labelaa"
            message=""
            :id="`create-new-label-modal${actionName}`"
            :showConfirmBtn="true"
            :showCancelBtn="false"
            confirm-btn-text="Save"
            @on-confirm="createNewLabel"
        >
            <create-new-label-template
            :form-data = "formData"
            :action-name="actionName" :all-labels="allLabels"
            >

            </create-new-label-template>
        </confirmation-popup>

    </component>


</template>

<script>
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
import CommonLabelTemplate from "@/modules/common/components/CommonLabelTemplate.vue";
import {createNewLabelApi, saveSelectedLabelsApi} from "@/modules/common/api";
import {EventBus} from "@/events/event-bus";
import CreateNewLabelTemplate from "@/modules/common/components/CreateNewLabelTemplate.vue";
import commonLabelTemplate from "@/modules/common/components/CommonLabelTemplate.vue";

export default {
    name: "CommonLabels",
    components: {CreateNewLabelTemplate, CommonLabelTemplate, ConfirmationPopup},
    props: {
        uniqueId: Number,
        labels: Array,
        actionName: String,
        listContainer: String,
        baseUrl:{
            required:true,
        },
        allLabels: null
    },
    data(){
      return {
          formData: {
              labelName: '',
              color: '',
              parentLabel: null,
          },
          selectedLabels : this.labels ?[...this.labels]:[],
      }
    },
    methods: {
        getLabelName(label) {
          return label.label_name
        },
        handleClick() {
            let fullUrl = window.location.href;
            const url = new URL(fullUrl);
            window.popupi('Add Label',`${url.protocol}//${url.hostname}/customer/label/select-label/${this.uniqueId}?color=1`);
        },
         saveLabels() {
                try {
                    let ids = this.selectedLabels.map(label => label.id);
                    let url = 'customer/label/select-label'
                    if (this.actionName == "contractorSelectLabel"){
                        url = 'contractor/label/select-label'
                    }
                     saveSelectedLabelsApi(url,this.uniqueId,ids).then(response => {
                         // this.labels = [...this.selectedLabels];
                     });
                }catch (error) {
                    console.error("Error saving labels:", error);
                }
        },
        openNewLabelModal(){
            $(`#AddLabelPopup${this.actionName}`).modal('hide')
            $(`#create-new-label-modal${this.actionName}`).modal('show')
        },
        createNewLabel(){
            let vm = this
            let url = `customer/label/add-label/${vm.uniqueId}`
            if (this.actionName == "contractorSelectLabel"){
                url = `contractor/label/add-label/${vm.uniqueId}`
            }
            createNewLabelApi(this.formData,url,vm.uniqueId).then((response) => {
                let newLabel = {
                    company_id:response.data.company_id,
                    id:response.data.label_id,
                    label_color:'#'+vm.formData.color,
                    label_name:vm.formData.labelName,
                }
                vm.selectedLabels.push(newLabel)
            })
        },
        initiateEventListeners() {
          let vm = this;
            EventBus.$on('addLabelPopupOpen',(type)=>{
              // if vm.actionName string incluede type then open the modal
              if (vm.actionName.includes(type)){
                  $(`#AddLabelPopup${vm.actionName}`).modal('show')
              }
            })

        }
    },

    mounted() {
        this.initiateEventListeners();
    },
    watch:{
        selectedLabels(newValue, oldValue) {
            if (newValue.length !== oldValue.length) {
                this.saveLabels()
            }
        }
    }
}
</script>

<style scoped>

</style>